<template>
    <div id = 'project' class = 'container-fluid animated fadeIn text-white'>
      <div class = 'jumbotron-fluid'>
        <h1>
          <strong>
            {{ this.project.title }}
          </strong>
        </h1>

        <div class = "text-center">
          <i class = "fas fa-arrow-alt-circle-left fa-3x float-left" v-on:click = "listener('ArrowLeft')"></i>
          <em>
            Use left / right arrows to navigate
          </em>
          <i class = "fas fa-arrow-alt-circle-right fa-3x float-right" v-on:click = "listener('ArrowRight')"></i>
        </div>
      </div>
      <div id = 'backBtn' class = ''>
        <div id = 'btnHolder' class = 'col-12 text-center p-3'>
          <a v-bind:href="this.project.url" target='_blank'>
            <button class = 'btn btn-sm btn-outline-secondary px-3 mb-3'>
              Try it out!
            </button>
          </a>
          <a v-bind:href="this.project.repoUrl" target='_blank'>
            <button class = 'btn btn-sm btn-outline-secondary px-3 mb-3'>
              GitHub
            </button>
          </a>
          <button class = 'btn btn-sm btn-outline-secondary px-3 mb-3' v-on:click= 'changer'>
            Back to Portfolio
          </button>
        </div>
      </div>

      <div id = 'content'>
        <div class = 'row'>
          <div class = 'col-sm-12 col-md-6'>
            <a v-bind:href="this.project.url" target="_blank">
              <img v-bind:src='this.project.img' class = 'float-left img-fluid rounded'/>
            </a>
          </div>
          
          <div class = 'col-sm-12 col-md-6'>

            <h5 class = 'text-left'>
              <strong>
                Project Summary:
              </strong>  
            </h5>

            <p class = 'text-left'>
              {{ this.project.text }}
            </p>
            
            <br />

            <div class = 'text-left'>
              <h5>
                <strong>
                  Technologies/Libraries Used:
                </strong>  
              </h5>

              <ul>
                <li v-for = "(technology, index) in project.tech" v-bind:key = "index"> {{ technology }} </li>
              </ul>
            </div>

            <br />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery'
import portfolioItems from '@/assets/portfolioItems'

export default {
  name: 'Project',
  data () {
    return {
      listenerAdded: false,
      currentIndex: this.$route.params.project,
      project: portfolioItems[this.$route.params.project]
    }
  },
  mounted () {
    this.listenerChecker()
  },
  updated () {
    this.listenerAdded = true
  },
  methods:{
    changer: function() {
      $('#project').addClass('animated fadeOut')
      const newUrl= "/portfolio"
      
      setTimeout ( function () {
        $('#project').removeClass('animated fadeOut')
        window.location.hash = newUrl
      }, 1000)
    },
    listenerChecker: function () {

      if(this.listenerAdded === false){
        this.listenerAdded = true
        
        window.addEventListener('keyup', ($event) => {
          this.listener($event.key)
        })
      }
    },
    listener: function (input) {
      let hashParts = window.location.hash.split('/')
      let index = parseInt(hashParts[2])
      let vm = this

      $('#project').removeClass('animated fadeIn')
      $('#project').addClass('animated fadeOut')
      
      if(input === 'ArrowRight' && hashParts[1] === 'portfolio') {
        let newLength = portfolioItems.length - 1
        if(index < newLength){
          index += 1
        } else {
          index = 0
        }
        reassemble()
      } else if (input === 'ArrowLeft' && hashParts[1] === 'portfolio') {
        if(index !== 0){
          index -= 1
        } else {
          index = portfolioItems.length - 1
        }
        reassemble()
      }

      function reassemble () {
        const newUrl = hashParts[0] + '/' + hashParts[1] + '/' + index
        setTimeout(function(){
          $('#project').removeClass('animated fadeOut')
          $('#project').addClass('animated fadeIn')
          window.location.hash = newUrl
          vm.$data.project = portfolioItems[index]
        }, 1000)        
      }
    }
  }
}
</script>

<style scoped>
h1 {
  color: #4ecdc4;
  /* margin-bottom: 20px; */
}

h1:hover {
  color: #ff6b6b;
}

i {
  color: #4ecdc4;
}

i:hover {
  color: #ff6b6b;
}

em {
  color: #ff6b6b;
}

img {
  /* width: 40%; */
  height: auto;
}

#backBtn {
    background-color: #292f36;
}

#btnHolder {
  padding: 0px!important;
}

#buttons {
  margin-bottom: 20px;
}

#content {
  background-color: #f6f7eb;
  color: #292f36;
  padding: 30px;
  min-height: 550px;
}

#project {
    background-color: #f6f7eb;
}

@media screen and (max-width: 627px){
  h1 {
    font-size: 25px;
    margin-bottom: 0px;
  }

  i {
    font-size: 40px;
  }

  .jumbotron-fluid {
    background-color: #292f36;
    padding-left: 5%;
    padding-right: 5%;
    margin-right: -5%;
    margin-left: -5%;
  }

  #backBtn {
    margin-bottom: 20px;
    margin-right: -5%;
    margin-left: -5%;
  }

  #buttons {
    margin-top: 20px;
  }

  /* #project {
    background-color: #f6f7eb
  } */
}

@media screen and (min-width: 627px){
  h1 {
    margin-bottom: 0px!important;
  }

  .jumbotron-fluid {
    background-color: #292f36;
    padding-left: 2%;
    padding-right: 2%;
    margin-right: -2%;
    margin-left: -2%;
  }

  #backBtn {
    padding-left: 2%;
    padding-right: 2%;
    margin-right: -2%;
    margin-left: -2%;
    margin-bottom: 20px;
  }

  #buttons {
    margin-top: 20px;
  }

  #project {
    min-height: 750px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Project.vue